<template>
  <BoxWithTitle>
    <template #header>
      <v-toolbar-title>
        {{ title }}
      </v-toolbar-title>
    </template>
    <template
      v-if="hasPermission('accessGroups.edit')"
      #icons
    >
      <v-btn
        icon
        @click="onClickToggle"
      >
        <v-icon>
          {{ formEditable ? 'mdi-close' : 'mdi-pencil-outline' }}
        </v-icon>
      </v-btn>
    </template>
    <template #content>
      <form>
        <AdminAccessGroupForm
          ref="mainForm"
          :populateWith="updatedData"
          :isEditable="formEditable"
          @dirtyChanged="isFormDirty = $event"
          @validChanged="isFormValid = $event"
          @sendData="updateData"
        />
        <v-row
          v-if="formEditable"
          align="center"
          justify="end"
          class="mr-1"
        >
          <v-btn
            v-if="hasPermission('accessGroups.remove')"
            text
            @click="onClickConfirmRemove"
          >
            <span class="text-danger">
              {{ $t('forms.btn.delete') }}
            </span>
          </v-btn>
          <v-btn
            :disabled="!isFormValid || !isFormDirty"
            type="submit"
            color="secondary"
            @click.prevent="onClickUpdate"
          >
            {{ $t('forms.btn.save') }}
          </v-btn>
        </v-row>
      </form>
    </template>
  </BoxWithTitle>
</template>

<script>
import Vue from 'vue';
import { mapGetters, mapActions } from 'vuex';
import FormPageMixin from '@/mixins/FormPageMixin';
import ConfirmForm from '@/components/shared/widgets/ConfirmForm.vue';
import BoxWithTitle from '@/components/shared/containers/VBoxWithTitle.vue';
import AdminAccessGroupForm from '@/components/forms/AdminAccessGroupForm.vue';

export default {
    components: {
        BoxWithTitle,
        AdminAccessGroupForm,
    },
    mixins: [
        FormPageMixin,
    ],
    computed: {
        ...mapGetters([
            'accessGroup',
            'hasPermission',
        ]),
        defaultData() {
            return this.accessGroup;
        },
        title() {
            return this.$route.params.accessGroupId
                ? this.$t('accessGroups.update')
                : this.$t('accessGroups.add');
        },
    },
    methods: {
        ...mapActions({
            reloadAccessGroup: 'getAccessGroupInfo',
            resetAccessGroup: 'resetAccessGroupInfo',
        }),
        async onClickUpdate() {
            const { id } = this.accessGroup;
            const payload = {
                clients: this.updatedData.clients,
                groupLeaders: this.updatedData.groupLeaders,
                members: this.updatedData.members,
                name_en: this.updatedData.name_en,
                name_fr: this.updatedData.name_fr,
            };
            await this.$rq.updateAccessGroup(id, payload);
            await this.reloadAccessGroup(id);

            this.cancelModifications();
            this.$toasted.global.toast_success({
                message: this.$t('msg.accessGroupUpdated', {
                    data: this.accessGroup.name,
                }),
            });
        },
        onClickConfirmRemove() {
            this.$root.$emit('showModal', {
                title: this.$t('accessGroups.remove'),
                component: Vue.component('ConfirmForm', ConfirmForm),
                payload: {
                    msg: this.$t('accessGroups.confirmRemove'),
                },
                onConfirm: () => this.removeRequest(),
                isForm: false,
            });
        },
        async removeRequest() {
            const { id } = this.accessGroup;
            await this.$rq.deleteAccessGroup(id);
            await this.resetAccessGroup(id);

            this.$toasted.global.toast_success({
                message: this.$t('msg.accessGroupRemoved', {
                    data: this.accessGroup.name,
                }),
            });

            await this.$router.push({
                name: 'accessGroups',
            });
        },
    },
};
</script>
